import { CurrencyFormat } from "../../../../components/helpers";

export const convertListGadai = (data) => {
    let converted

    if (!Array.isArray(data)) {
        if (data.payment_type === 'installment') {
            let installments = getInstallmentForPay(data.gadai_installment)
            converted = {
                id: data.id,
                sbg: data.sbg_code,
                receiptCode: data.receipt_code,
                customerName: data.ktp_name,
                billAmount: `Rp ${CurrencyFormat(data?.remainder_loan_amount) || 0}`,
                fineAmount: `Rp ${CurrencyFormat(data.fee_late) || 0}`,
                installments: installments,
                paymentType: data.payment_type,
                interestExpense: data.interest_expense_type,
                detail: installments[0]?.value,
            }
        } else {
            converted = {
                id: data.id,
                sbg: data.sbg_code,
                receiptCode: data.receipt_code,
                customerName: data.ktp_name,
                billAmount: `Rp ${CurrencyFormat(data.remainder_loan_amount) || 0}`,
                fineAmount: `Rp ${CurrencyFormat(data.fee_late) || 0}`,
                paymentType: data.payment_type,
                interestExpense: data.interest_expense_type,
                detail: {
                    billAmount: `Rp ${CurrencyFormat(data.remainder_loan_amount) || 0}`,
                    capitalLoan: `Rp ${CurrencyFormat(data.capital_loan) || 0}`,
                    savingInsurance: `Rp ${CurrencyFormat(data.fee_saving_assurance) || 0}`,
                    feeSaving: `Rp ${CurrencyFormat(data.fee_saving) || 0}`,
                    feeLate: `Rp ${CurrencyFormat(data.fee_late) || 0}`,
                },
            }
        }
    } else {
        let dataConverted = []
        data.forEach((item, index) => {
            if (item.payment_type === 'installment') {
                let installments = getInstallmentForPay(item.gadai_installment)
                dataConverted.push({
                    key: index + 1,
                    id: item.id,
                    sbg: item.sbg_code,
                    receiptCode: item.receipt_code,
                    customerName: item.ktp_name,
                    billAmount: `Rp ${CurrencyFormat(item?.remainder_loan_amount) || 0}`,
                    fineAmount: `Rp ${CurrencyFormat(item.fee_late) || 0}`,
                    installments: installments,
                    paymentType: item.payment_type,
                    interestExpense: item.interest_expense_type,
                    detail: installments[0]?.value,
                });
            } else {
                dataConverted.push({
                    key: index + 1,
                    id: item.id,
                    sbg: item.sbg_code,
                    receiptCode: item.receipt_code,
                    customerName: item.ktp_name,
                    billAmount: `Rp ${CurrencyFormat(item.remainder_loan_amount) || 0}`,
                    fineAmount: `Rp ${CurrencyFormat(item.fee_late) || 0}`,
                    paymentType: item.payment_type,
                    interestExpense: item.interest_expense_type,
                    detail: {
                        billAmount: `Rp ${CurrencyFormat(item.remainder_loan_amount) || 0}`,
                        capitalLoan: `Rp ${CurrencyFormat(item.capital_loan) || 0}`,
                        savingInsurance: `Rp ${CurrencyFormat(item.fee_saving_assurance) || 0}`,
                        feeSaving: `Rp ${CurrencyFormat(item.fee_saving) || 0}`,
                        feeLate: `Rp ${CurrencyFormat(item.fee_late) || 0}`,
                    },
                });
            }
            converted = dataConverted
        });
    }
    return converted;
};

const getInstallmentForPay = (data) => {
    if (!data || data.length === 0) return [];
    let dataInstallment = []
    data.map(item => {
        if (item.status === 'ongoing' || item.status === 'payment-late') {
            dataInstallment.push({
                label: `Cicilan ke-${item.period_number}`,
                value: {
                    id: item.id,
                    billAmount: `Rp ${CurrencyFormat(item.installment_amount) || 0}`,
                    capitalLoan: `Rp ${CurrencyFormat(item.capital_loan) || 0}`,
                    savingInsurance: `Rp ${CurrencyFormat(item.fee_saving_assurance) || 0}`,
                    feeLateDays: `Rp ${CurrencyFormat(item.late_charge_days) || 0}`,
                    feeLatePeriod: `Rp ${CurrencyFormat(item.late_charge_period) || 0}`,
                }
            })
        }
    })
    return dataInstallment
}